import { DELETE, FETCH_ALL_POSTS, FETCH_MY_POSTS, FETCH_BY_PAGE, FETCH_BY_SEARCH, CREATE, UPDATE, START_LOADING, END_LOADING, FETCH_POST, UPDATE_RETURN_ONE } from "../constants/actionTypes"
import * as api from "../api/index.js"

/***** Creamos acciones especificadas en API. La enviamos a reducers *****/

// Action creators with redux Thunk

export const getPost = (id) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.fetchPost(id)
        dispatch({ type: FETCH_POST, payload: { post: data } })
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}

export const getMyPosts = (id) => async (dispatch) => {

    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.fetchMyPosts(id)
        dispatch({ type: FETCH_MY_POSTS, payload: { posts: data } })
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}

export const getPostsByPage = (info) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.fetchPostsByPage(info)
        dispatch({ type: FETCH_BY_PAGE, payload: data })
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}

export const getPopularPosts = () => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.fetchPopularPosts();
        dispatch({ type: FETCH_ALL_POSTS, payload: data });
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}

export const getPostsBySearch = (searchQuery) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.fetchPostsBySearch(searchQuery)
        dispatch({ type: FETCH_BY_SEARCH, payload: data })
        dispatch({ type: END_LOADING })
    } catch (error) {
    }
}

export const createPost = (post, history) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.createPost(post);
        dispatch({ type: CREATE, payload: data });
        alert("Añadido!")
    } catch (error) {
        alert("Ya existe! Búscalo para guardarlo en tu cuenta")
    }
}

export const updatePost = (id, post, message, setMessage) => async (dispatch) => {
    try {
        const { data } = await api.updatePost(id, post)
        dispatch({ type: UPDATE, payload: data })
    } catch (error) {
        setMessage(!message)
    }
}

export const updatePostReturnOne = (id, post) => async (dispatch) => {
    try {
        const { data } = await api.updatePost(id, post)
        dispatch({ type: UPDATE_RETURN_ONE, payload: data })
    } catch (error) {
        alert("Has alcanzado tu límite! \nQuita alguno antes o mejora tu cuenta")
    }
}

export const deletePost = (id) => async (dispatch) => {
    try {
        await api.deletePost(id)
        dispatch({ type: DELETE, payload: id })

    } catch (error) {
        console.log(error)
    }
}

export const likePost = (id) => async (dispatch) => {
    try {
        const { data } = await api.likePost(id);
        dispatch({ type: UPDATE, payload: data });
    } catch (error) {
        console.log(error.message);
    }
};
